import React from "react";
import { formatDateOnly, formatDateTimeIso, formatMoney, formatNumber } from "../units/format";
import { useEffectiveUnits } from "../units/useEffectiveUnits";

const VALUE_TYPE_DATE = "date";
const VALUE_TYPE_DATE_TIME = "dateTime";
const VALUE_TYPE_MONEY = "money";
const VALUE_TYPE_DIGIT = "digit";
const VALUE_TYPE_PERCENT = "percent";
const DATE_ONLY_LENGTH = 10;

/**
 * Formatierung von Listenspalten mit `valueType` (date, dateTime, money, digit, percent) ohne eigenes
 * `render` für die Zeilenliste `SettingsListRows` — über die Format-Helfer aus `app/units/format`.
 * Unbekannte Typen liefern `undefined` (Rohwert).
 */
export function useListValueFormatter() {
  const units = useEffectiveUnits();
  return React.useCallback((valueType: string, value: unknown): React.ReactNode | undefined => {
    const numeric = typeof value === "number" ? value : typeof value === "string" && value.trim() !== "" ? Number(value) : Number.NaN;
    switch (valueType) {
      case VALUE_TYPE_DATE:
        return typeof value === "string" ? formatDateOnly(value.slice(0, DATE_ONLY_LENGTH), units) : undefined;
      case VALUE_TYPE_DATE_TIME:
        return typeof value === "string" ? formatDateTimeIso(value, units) : undefined;
      case VALUE_TYPE_MONEY:
        return Number.isFinite(numeric) ? formatMoney(numeric, units) : undefined;
      case VALUE_TYPE_DIGIT:
        return Number.isFinite(numeric) ? formatNumber(numeric, units) : undefined;
      case VALUE_TYPE_PERCENT:
        return Number.isFinite(numeric) ? `${formatNumber(numeric, units, { maximumFractionDigits: 1 })} %` : undefined;
      default:
        return undefined;
    }
  }, [units]);
}
